import * as utils from './utils'

export default {
  ...utils             // 工具类
}



// WEBPACK FOOTER //
// ./src/assets/utils/index.js